
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";

import "../../../cssFiles/reviews.scss";

const videos = [
  {
    id: "OmfJrVfS9js",
    name: "Mr. Balachandar Ganesan",
    profession: "Data Architect",
    location: "Chennai, Tamil Nadu",
    comment: "Niveza is a wonderful company",
  },
  {
    id: "aGqDPJzRiEw",
    name: "Mr. Balaji Fugate",
    profession: "IT professional",
    location: "Maharashtra",
    comment: "Excellent service and very professional team",
  },
  {
    id: "e1ng4aDrz_E",
    name: "Mr. Nirmal Sur",
    profession: "Businessman",
    location: "Gujrat",
    comment: "Highly recommend Niveza.",
  },
  // {
  //   id: "V79D8__4W9g",
  //   name: "Amit Singh",
  //   profession: "Startup Founder",
  //   location: "Mumbai",
  //   comment: "Great experience from start to finish",
  // },
  // {
  //   id: "rfTgO9rpqck",
  //   name: "Neha Patel",
  //   profession: "Marketing Lead",
  //   location: "Ahmedabad",
  //   comment: "Very reliable and supportive team",
  // },
];


const YoutubeTestimonials = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  // Handler to set the active video index
  const handlePlay = (index) => {
    setActiveIndex(index);
  };

  return (
    <div className="reviews-wrapper">
      {/* Left Button */}
      <button className="swiper-btn prev-btn" aria-label="Previous">
        <FaAngleLeft color="white" size={28} />
      </button>

      {/* Right Button */}
      <button className="swiper-btn next-btn" aria-label="Next">
        <FaAngleRight color="white" size={28} />
      </button>

      <Swiper
        modules={[Navigation]}
        loop={true}
        navigation={{
          prevEl: ".prev-btn",
          nextEl: ".next-btn",
        }}
        spaceBetween={16}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
      >
        {videos.map((video, index) => (
          <SwiperSlide key={`${video.id}-${index}`}>
            <div className="video-card">
              {/* YouTube Video */}
              <div className="video-wrapper">
                <LiteYouTubeEmbed
                  id={video.id}
                  title={video.name}
                  key={activeIndex === index ? `${video.id}-active` : `${video.id}-inactive`}
                  onIframeAdded={() => handlePlay(index)}
                />
              </div>

              {/* Testimonial Content */}
              <div className="testimonial-info">
                <h4>{video.name}</h4>
                <span className="meta">
                  {video.profession} · {video.location}
                </span>
                <p className="comment">
                  “{video.comment}”
                </p>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default YoutubeTestimonials;

// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";

// import LiteYouTubeEmbed from "react-lite-youtube-embed";
// import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
// import { FaAngleRight, FaAngleLeft} from "react-icons/fa";

// import "../../../cssFiles/reviews.scss";

// const videos = [
//   { id: "2l2GXPlfi4Q", title: "Video 1" },
//   { id: "--eH76tgoNw", title: "Video 2" },
//   { id: "sZrTJesvJeo", title: "Video 3" },
//   { id: "V79D8__4W9g", title: "Video 4" },
//   { id: "rfTgO9rpqck", title: "Video 5" },
// ];

// const Reviews = () => {
//   return (
//     <div className="reviews-wrapper">
//       {/* Left Button */}
//       <button className="swiper-btn prev-btn" aria-label="Previous">
//         ‹
//       </button>

//       {/* Right Button */}
//       {/* <button className="swiper-btn next-btn" aria-label="Next">
//         ›
//       </button> */}

//     {/* Left Button */}
//     <button className="swiper-btn prev-btn" aria-label="Previous">
//     <FaAngleLeft color="white" size={28} />
//     </button>

//     {/* Right Button */}
//     <button className="swiper-btn next-btn" aria-label="Next">
//     <FaAngleRight color="white" size={28} />
//     </button>
      

//       <Swiper
//         modules={[Navigation]}
//         loop={true} 
//         navigation={{
//           prevEl: ".prev-btn",
//           nextEl: ".next-btn",
//         }}
//         spaceBetween={16}
//         slidesPerView={1}
//         breakpoints={{
//           640: { slidesPerView: 2 },
//           1024: { slidesPerView: 3 },
//         }}
//       >
//         {videos.map((video, index) => (
//           <SwiperSlide key={`${video.id}-${index}`}>
//             <div className="video-card">
//               <LiteYouTubeEmbed
//                 id={video.id}
//                 title={video.title}
//               />
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//   );
// };

// export default Reviews;



